import {Pipe, PipeTransform} from '@angular/core';
import {AppTextService} from "@fi-shared/app-text";

@Pipe({
    name: 'ficAppText',
    standalone: false
})
export class FicAppTextPipe implements PipeTransform {

    constructor(private appTextService: AppTextService ) {

    }

    transform(value: any, args?: any): any {
        return this.appTextService.get(value, args);
    }

}
